import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import backend from "../api";
import {
  CircularProgress,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const VerifyAccount = () => {
  const { token } = useParams();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        const response = await backend.post("/auth/verify-account", { token });

        if (response.status === 200) {
          toast.success(response.data.message);
          setIsVerified(true);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error verifying account:", error.message);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast.error(error.response.data.message);
          setIsVerified(false);
          setErrorMessage(error.response.data.message);
        } else {
          toast.error("Verification failed. Please try again.");
          setErrorMessage("Verification failed. Please try again.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    verifyAccount();
  }, [token]);

  const handleGoBack = () => {
    history.push("/"); 
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="40vh"
    >
      <ToastContainer />
      <Card
        style={{
          width: "800px",
          textAlign: "center",
          background: isVerified ? "#e8f5e9" : "#ffebee",
        }}
      >
        <CardContent>
          {isLoading ? (
            <>
              <CircularProgress />
              <Typography variant="h6" mt={2}>
                Verifying your account, please wait...
              </Typography>
            </>
          ) : isVerified ? (
            <>
              <CheckCircleIcon
                style={{ fontSize: 80, color: "#4caf50", marginBottom: "16px" }}
              />
              <Typography
                variant="h4"
                style={{ color: "#388e3c", marginBottom: "16px" }}
              >
                Account Verified!
              </Typography>
              <Typography variant="body1" style={{ marginBottom: "24px" }}>
                Your account has been successfully verified.
              </Typography>
              <Button
                variant="contained"
                color="success"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
                style={{ borderRadius: "8px" }}
              >
                Go to Login
              </Button>
            </>
          ) : (
            <>
              <ErrorIcon
                style={{ fontSize: 80, color: "#d32f2f", marginBottom: "16px" }}
              />
              <Typography
                variant="h4"
                style={{ color: "#b71c1c", marginBottom: "16px" }}
              >
                Verification Failed!
              </Typography>
              <Typography
                variant="body1"
                style={{ marginBottom: "24px", color: "#b71c1c" }}
              >
                {errorMessage ||
                  "The verification link is invalid or expired. Please contact support for assistance."}
              </Typography>
              <button
                type="submit"
                  className="btn btn-danger"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
                button
              >
                Go Back
              </button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VerifyAccount;
